import "@/styles/chrisWelt.css";

// CHRIS · DOKUMENTENWELT READINESS-AKTIVITÄT (Phase C1, 2026-06)
// IMPLEMENTED / TECHNICALLY VERIFIED / AWAITING OPERATOR LIVE APPROVAL — NICHT FROZEN.
//
// Ersetzt das browseranfällige Strichmännchen im Readiness-/Fertigstellungs-
// bereich der Dokumentenwelt (Welt.jsx · ReadinessAmpel) durch Chris.
// Der ECHTE Backend-Readiness-Zustand (`readiness.status` aus
// `GET /api/courses/{id}/release-readiness`) ist ALLEINIGE Wahrheit — diese
// Komponente rendert nur die passende Pose und ist rein dekorativ:
//   RUNNING → Pose 22 THINK/CHECK + ruhige, endlose Arbeitsbewegung
//             (compositor-freundlich AUSSCHLIESSLICH über transform/translate3d;
//              KEIN left/top/margin, KEIN JS-Frame-Loop, kein setInterval)
//             + drei sehr dezente pulsierende Punkte (nur opacity) als
//             indeterministischer Aktivitätsindikator (KEIN Prozent/Fortschritt).
//   BLOCKED → Pose 20 ATTENTION, Bewegung + Punkte SOFORT gestoppt.
//   READY   → Pose 23 PRESENT/EXPLAIN, Bewegung + Punkte gestoppt.
//
// Nur FROZEN Character-Master-v1.1-Assets aus /chris/v1_1/production/ (§1).
// Keine Bildbearbeitung, keine Spiegelung/Verformung. Assistenzebene:
// aria-hidden (dekorativ) + pointer-events:none — die fachliche Statusinfo
// steht unabhängig im DOM der ReadinessAmpel. Die Endlos-CSS-Animation löst
// KEINE wiederholte aria-live-Ausgabe aus (kein DOM-/Textwechsel pro Zyklus).

const ASSET = "/chris/v1_1/production/";

const POSE = {
  running: { src: ASSET + "22_chris_think_check.png", num: "22" },
  blocked: { src: ASSET + "20_chris_attention.png", num: "20" },
  ready: { src: ASSET + "23_chris_present_explain.png", num: "23" },
};

export default function ChrisReadinessActivity({ status, forceReduced = false }) {
  const pose = POSE[status];
  if (!pose) return null; // nur echte Readiness-Zustände; nie bei loading/error
  const working = status === "running";

  return (
    <div
      className={`welt-chris${forceReduced ? " welt-chris--reduced" : ""}`}
      data-testid="welt-chris-activity"
      data-status={status}
      aria-hidden="true"
    >
      <img
        className="welt-chris-fig"
        src={pose.src}
        alt=""
        draggable="false"
        loading="eager"
        data-testid="welt-chris-figure"
        data-pose={pose.num}
        data-anim={working ? "work" : "still"}
      />
      {working && (
        <div className="welt-chris-dots" data-testid="welt-chris-dots">
          <span className="welt-chris-dot" />
          <span className="welt-chris-dot" />
          <span className="welt-chris-dot" />
        </div>
      )}
    </div>
  );
}
